import { Component } from "@angular/core";

@Component({
  selector: "app-in-app-page",
  templateUrl: "./in-app-page.component.html",
  styleUrls: ["./in-app-page.component.scss"],
})
export class InAppPageComponent {}
